import type { InactiveSelectOption } from "@components/Dialog/Receipt/select";

export type EntityErrorOptions = {
  branchs: InactiveSelectOption[];
  segments: InactiveSelectOption[];
  suppliers: InactiveSelectOption[];
  categories: InactiveSelectOption[];
  subCategories: InactiveSelectOption[];
};

export type EntityErrorMessages = {
  branchRequired: string;
  branchInactive: string;
  segmentInactive: string;
  supplierInactive: string;
  categoryRequired: string;
  categoryInactive: string;
  subcategoryInactive: string;
};

export type EntityErrorValues = {
  branch: string;
  segment: string;
  supplier: string;
  category: string;
  subcategory: string;
};

export const buildEntityErrors = (
  form: EntityErrorValues,
  options: EntityErrorOptions,
  messages: EntityErrorMessages
): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!form.branch) errors.branch = messages.branchRequired;
  else if (form.branch === "Selecione") errors.branch = messages.branchRequired;
  else if (options.branchs.find((b) => b.id === form.branch)?.inactive) errors.branch = messages.branchInactive;

  if (form.segment && options.segments.find((s) => s.id === form.segment)?.inactive)
    errors.segment = messages.segmentInactive;

  if (form.supplier && options.suppliers.find((s) => s.id === form.supplier)?.inactive)
    errors.supplier = messages.supplierInactive;

  if (!form.category) errors.category = messages.categoryRequired;
  else if (options.categories.find((c) => c.id === form.category)?.inactive)
    errors.category = messages.categoryInactive;

  if (form.subcategory && options.subCategories.find((s) => s.id === form.subcategory)?.inactive)
    errors.subcategory = messages.subcategoryInactive;

  return errors;
};
